import {
    ActionSpinOptions,
    ActionSpinSound,
    ASWinData,
    PromoPanelGameConfiguration
} from "@nolimitcity/promo-panel/bin/interfaces/ASInterfaces";
import {ASMainGamePickOptions, WINTYPE} from "@nolimitcity/promo-panel/bin/enums/ASEnums";
import {DumpsterFireGameMode} from "./game/server/DumpsterFireGameMode";
import {DumpsterFireGameAssets} from "./game/DumpsterFireGameAssets";
import {DumpsterFireGameData} from "./game/server/DumpsterFireData";
import {DumpsterFire} from "./game/DumpsterFire";
import {DumpsterFireSound} from "./game/sound/DumpsterFireSound";
import {Helper} from "@nolimitcity/promo-panel/bin/utils/Helper";
import {MathHelper} from "@nolimitcity/slot-game/bin/utils/MathHelper";


export class DFPromoPanelConfig implements PromoPanelGameConfiguration {

    private modeBeforeCrashGame = "NORMAL";
    private prevAmount: number = 0;

    constructor() {
    }

    public getActionSpinOptions(): ActionSpinOptions {
        return {
            gameName: "DuckHunter",
            hasActionSpin: true,
            mainGame: {
                header: () => "xBET",
                options: [
                    {name: "NORMAL", id: 0, image: "NORMAL.png"}
                ],
                type: ASMainGamePickOptions.BOOSTED_BET
            },
            graphics: {backgroundTextureName: DumpsterFireGameAssets.MAIN_GAME_BACKGROUND},
            getParsedData: (response: DumpsterFireGameData, bet: number, prevResponse: DumpsterFireGameData): ASWinData => {
                const parsedData: ASWinData = {
                    totalWin: response.accumulatedRoundWin,
                    wasFeatureBuy: response.wasFeatureBuy,
                    freeSpinTriggeredThisSpin: this.isFreeSpinTriggered(response),
                    totalSpinWinnings: this.getSpinWin(response, prevResponse),
                    isBigWin: this.isBigWin(response, prevResponse),
                    winType: WINTYPE.NORMAL,
                    featureName: this.getFeatureName(response, prevResponse),
                    isRoundComplete: this.isRoundComplete(response, prevResponse),
                    isBonusEnd: this.isBonusEnd(response),
                    isWinCapHit: response.brokeTheBank,
                }
                return parsedData;
            }
        };
    }

    public onActionSpinPlaySound(trigger: ActionSpinSound): void {
        if (trigger == ActionSpinSound.WIN) {
            DumpsterFire.soundPlayer.playSound(DumpsterFireSound.AS_WIN);
        } else if (trigger == ActionSpinSound.BIG_WIN) {
            DumpsterFire.soundPlayer.playSound(DumpsterFireSound.AS_WIN_BIG);
        }
    }

    private isBigWin(response: DumpsterFireGameData, prevResponse: DumpsterFireGameData): boolean {
        let win = response.spinWin;
        // fix for extra spin rounds
        if (response.mode == DumpsterFireGameMode.EXTRA_SPIN && prevResponse == undefined) {
            win = response.accumulatedRoundWin;
        }
        if (response.nextMode === DumpsterFireGameMode.EXTRA_SPIN) {
            this.prevAmount = response.spinWin;
        }
        if (response.mode == DumpsterFireGameMode.EXTRA_SPIN) {
            win = this.prevAmount;
        }
        if (response.wasFeatureBuy) {
            const betPrice = DumpsterFire.getBuyFeaturePrice();
            let winRatio: number = Helper.ceilToDecimals((win / betPrice), 2);
            return winRatio >= 1;
        }
        if (DumpsterFire.model.boostedBetName !== "BOOSTED_BET" && DumpsterFire.model.boostedBetName !== "BOOSTED_BET_STATE_2" && DumpsterFire.model.data.boostedBet) {
            const betPrice = DumpsterFire.getBuyFeaturePrice();
            let winRatio: number = Helper.ceilToDecimals((win / betPrice), 2);
            return winRatio >= 1;
        }
        let winRatio: number = Helper.ceilToDecimals((win / response.playedBetValue), 2);
        return winRatio >= 15;
    }

    private isFreeSpinTriggered(response: DumpsterFireGameData): boolean {
        return (response.mode === DumpsterFireGameMode.NORMAL || response.mode === DumpsterFireGameMode.NORMAL_AVALANCHE) && (response.nextMode == DumpsterFireGameMode.FREESPIN);
    }

    private getFeatureName(response: DumpsterFireGameData, prevResponse: DumpsterFireGameData): string {
        const getModeName = (mode: DumpsterFireGameMode) => {
            switch (mode) {
                case DumpsterFireGameMode.FREESPIN:
                    if (response.upgradedSymbols.length == 1) {
                        return "DUCK HUNT SPINS"
                    } else if (response.upgradedSymbols.length == 2) {
                        return "HAWK EYE SPINS"
                    } else if (response.upgradedSymbols.length == 3) {
                        return "BIG GAME SPINS"
                    }
                    return "FREESPIN";
                case DumpsterFireGameMode.FREESPIN_AVALANCHE:
                    if (response.upgradedSymbols.length == 1) {
                        return "DUCK HUNT SPINS"
                    } else if (response.upgradedSymbols.length == 2) {
                        return "HAWK EYE SPINS"
                    } else if (response.upgradedSymbols.length == 3) {
                        return "BIG GAME SPINS"
                    }
                    return "FREESPIN_AVALANCHE";
                case DumpsterFireGameMode.EXTRA_SPIN:
                    return this.modeBeforeCrashGame;
                default:
                    return "NORMAL";
            }
        };

        if (response.nextMode == DumpsterFireGameMode.EXTRA_SPIN) {
            this.modeBeforeCrashGame = getModeName(response.mode);
        }

        if (DumpsterFire.model.triggeredFreespins) {
            return getModeName(response.nextMode);
        } else {
            return getModeName(response.mode);
        }
    }

    onPlayBonusInGame(data: any): void {
        DumpsterFire.model.inActionSpin = false;
        DumpsterFire.keypadPlugin.hide();
        if (DumpsterFire.model.data.nextMode.indexOf("FREESPIN") > -1) {
            DumpsterFire.model.isFreespin = true;
        }
        DumpsterFire.bgMulti.removeMulti();
        DumpsterFire.bgFinalMulti.removeFinalMulti();

        DumpsterFire.fireFrame.removeAllSpines();
        DumpsterFire.allReelsView.removeAllMulti();

        DumpsterFire.model.onGame(data);
        DumpsterFire.allReelsView.addBonusInGameInitialMulti();
        DumpsterFire.apiPlugin.slotStates.resetGameStartedAndGameServerFlag();
        DumpsterFire.keypadPlugin.setWin(data.accumulatedRoundWin, true, DumpsterFire.isWinBelowStake());
        DumpsterFire.allReelsView.reInit();
        DumpsterFire.gameFlowController.start();
    }


    private isRoundComplete(response: DumpsterFireGameData, prevResponse: DumpsterFireGameData): boolean {
        const modes = [
            DumpsterFireGameMode.FREESPIN,
            DumpsterFireGameMode.NORMAL,
        ]
        DumpsterFire.model.inActionSpin = true;

        // Handle base game
        if (!prevResponse && response.nextMode == DumpsterFireGameMode.EXTRA_SPIN) {
            return false;
        }
        if (!prevResponse && response.mode == DumpsterFireGameMode.EXTRA_SPIN) {
            return true;
        }

        // Keep round open in case last freespin and next mode is crash game in order to not display last round twice if player declines crash game
        if ((response.mode.indexOf("FREESPIN") > -1) && response.nextMode == DumpsterFireGameMode.EXTRA_SPIN) {
            return false;
        }
        // Close round after crash game choice is made
        else if (prevResponse && response.mode == DumpsterFireGameMode.EXTRA_SPIN && response.nextMode == DumpsterFireGameMode.EXTRA_SPIN) {
            return true;
        }
        this.prevAmount = 0;
        return modes.indexOf(response.nextMode) > -1
    }

    private isBonusEnd(response: DumpsterFireGameData): boolean {
        return response.mode != DumpsterFireGameMode.NORMAL && (response.nextMode == DumpsterFireGameMode.NORMAL)
    }

    private getSpinWin(response: DumpsterFireGameData, prevResponse: DumpsterFireGameData): number {
        if (response.mode == "EXTRA_SPIN" && prevResponse != undefined) {
            return prevResponse.spinWin;
        } else {
            return response.spinWin;
        }
    }
}